import * as React from "react";

export enum IconType {
	Svg,
	Png48,
	Png16,
}

export interface IMimeTypeIconProps {
	mimeType: string;
	iconType: IconType;
	style?: React.CSSProperties;
}

export class MimeTypeIcon extends React.Component<IMimeTypeIconProps, {}> {

	get iconSrc(): string {
		let mimeType = this.props.mimeType || "application/unknown";
		let extension = this.props.iconType === IconType.Svg ? ".svg" : ".png";
		let folder = this.props.iconType === IconType.Svg ? "svg" : this.props.iconType === IconType.Png16 ? "png16" : "png48";
		return "../../images/mimetypes/" + folder + "/" + mimeType.replace(/[\.\-\+\/]/g, "_") + extension;
	}

	render() {
		return <i>
			<img title={this.props.mimeType} src={this.iconSrc} style={this.props.style} />
		</i>
	}
}